import { render, staticRenderFns } from "./ReturnAndDiscountDialog.vue?vue&type=template&id=cf5c8df4&scoped=true&"
import script from "./ReturnAndDiscountDialog.vue?vue&type=script&lang=js&"
export * from "./ReturnAndDiscountDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf5c8df4",
  null
  
)

export default component.exports